import React from "react";
import { CalendarCheck, X } from "lucide-react";

// Shown once, to someone on the price screen who looks like they're about to
// leave. It offers a conversation, never a different price.
export default function WalkawayOffer({ offer, onBook, onDismiss }) {
  return (
    <div
      className="fixed inset-0 z-[60] flex items-end justify-center bg-navy/40 p-4 backdrop-blur-[2px] sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-label={offer.heading}
      data-testid="pricing-walkaway-offer"
    >
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-6 shadow-2xl md:p-8">
        <div className="flex items-start gap-4">
          <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-orange/10 text-orange">
            <CalendarCheck size={20} />
          </span>
          <div className="min-w-0">
            <h3 className="font-display text-base font-extrabold text-navy md:text-lg">{offer.heading}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{offer.body}</p>
          </div>
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Close"
            data-testid="pricing-walkaway-close"
            className="ml-auto shrink-0 text-slate-400 duration-200 [transition-property:color] hover:text-navy"
          >
            <X size={18} />
          </button>
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <button
            type="button"
            onClick={onBook}
            data-testid="pricing-walkaway-book"
            className="inline-flex items-center gap-2 rounded-full bg-orange px-7 py-3.5 font-bold text-white duration-300 [transition-property:transform,background-color] hover:-translate-y-0.5 hover:bg-orange-dark"
          >
            {offer.button_label || "Book a Discovery Call"} <CalendarCheck size={16} />
          </button>
          <button
            type="button"
            onClick={onDismiss}
            data-testid="pricing-walkaway-dismiss"
            className="text-sm font-semibold text-slate-500 duration-200 [transition-property:color] hover:text-navy"
          >
            {offer.dismiss_label || "No thanks, I'm just looking"}
          </button>
        </div>
      </div>
    </div>
  );
}
